export const voucherBannerDefaultAmount = {
  amount: 10,
  currency: 'EUR'
};
